module.exports = __webpack_public_path__ + "static/img/caa.09d27f1d.png";